import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { isFunction } from 'lodash';
import { BarLoader } from '@unite-us/ui';

// Produces unique but stable-between-renders ids to correlate dt and dd
// elements in combination with `useMemo`
var nextLineItemId = 1;
var lineItemIdFactory = function lineItemIdFactory() {
  return "line-item-".concat(nextLineItemId++);
};
var LineItem = function LineItem(_ref) {
  var children = _ref.children,
    dataTestElement = _ref.dataTestElement,
    isLoaded = _ref.isLoaded,
    field = _ref.field,
    fieldClassName = _ref.fieldClassName,
    valueClassName = _ref.valueClassName,
    colon = _ref.colon;
  var dtId = useMemo(lineItemIdFactory, []);
  var renderChildren = function renderChildren() {
    return isFunction(children) ? children() : children;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("dt", {
    className: fieldClassName,
    "data-testid": dataTestElement,
    "data-test-element": dataTestElement,
    id: dtId
  }, field, colon && ':'), /*#__PURE__*/React.createElement("dd", {
    "aria-describedby": dtId,
    className: valueClassName
  }, isLoaded ? renderChildren() : /*#__PURE__*/React.createElement(BarLoader, null)));
};
LineItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  field: PropTypes.node.isRequired,
  isLoaded: PropTypes.bool,
  dataTestElement: PropTypes.string,
  fieldClassName: PropTypes.string,
  valueClassName: PropTypes.string,
  colon: PropTypes.bool
};
LineItem.defaultProps = {
  children: '',
  isLoaded: true,
  dataTestElement: null,
  fieldClassName: 'text-text-blue text-sm font-bold leading-5 break-word',
  valueClassName: 'text-text-blue text-sm leading-5 break-word',
  colon: true
};
export default LineItem;
//# sourceMappingURL=LineItem.js.map